var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeOpenNew(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.04102 12.8202C1.04102 12.8202 5.20768 4.48688 12.4993 4.48688C19.791 4.48688 23.9577 12.8202 23.9577 12.8202C23.9577 12.8202 19.791 21.1535 12.4993 21.1535C5.20768 21.1535 1.04102 12.8202 1.04102 12.8202Z",
    stroke: "black",
    strokeWidth: 1.47059,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 15.9453C14.2259 15.9453 15.625 14.5462 15.625 12.8203C15.625 11.0944 14.2259 9.69531 12.5 9.69531C10.7741 9.69531 9.375 11.0944 9.375 12.8203C9.375 14.5462 10.7741 15.9453 12.5 15.9453Z",
    stroke: "black",
    strokeWidth: 1.47059,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpenNew);
export default __webpack_public_path__ + "static/media/eyeOpenNew.ec2d2891474bc1573a3b29ab079aa694.svg";
export { ForwardRef as ReactComponent };